import moment from 'moment'
const SYNC_CATEGORIES = [
  'coaching',
  'forms',
  'routePlan',
  'parameters',
  'research',
]
const IGNORE_DATE = ['coaching']

const syncStateModel = category => ({
  lastUpdate: null,
  updating: false,
  failCount: 0,
})

const syncStateCategoryModel = category => ({
  [category]: syncStateModel(),
})

const generateStates = () =>
  Object.assign({}, ...SYNC_CATEGORIES.map(syncStateCategoryModel))

export const state = () => ({
  // Derive the initial offline state from the browser API so it's always correct on startup.
  // Fallback to false (online) on SSR where navigator is not available.
  isOffline: typeof navigator !== 'undefined' ? !navigator.onLine : false,
  ...generateStates(),
})

export const getters = {
  list: state =>
    SYNC_CATEGORIES.filter(
      category => !IGNORE_DATE.includes(category)
    ).map((category, value) =>
      Object.assign(syncStateModel(), state[category] ?? {}, { category })
    ),
  outdated: (state, getters) =>
    !!getters.freshCategories.length ||
    getters.oldestUpdate <
      moment()
        .startOf('day')
        .toISOString(),
  oldestUpdate: (state, getters) =>
    getters.list
      .map(item => item.lastUpdate)
      .reduce((acc, cur) => (cur < acc ? cur : acc), new Date().toISOString()),
  freshCategories: (state, getters) =>
    getters.list.filter(item => !item.lastUpdate),
  updatingCategories: (state, getters) =>
    getters.list.filter(item => item.updating),
  failedCategories: (state, getters) =>
    getters.list.filter(item => item.failCount > 0),
}

export const mutations = {
  UPDATE: (state, category) => {
    const now = new Date()
    state[category].lastUpdate = now.toISOString()
    state[category].updating = false
    state[category].failCount = 0
  },
  UPDATING: (state, category) => {
    state[category].updating = true
  },
  FAILED: (state, category) => {
    state[category].updating = false
    state[category].failCount += 1
  },
  RESET: state => {
    for (let category of SYNC_CATEGORIES) {
      state[category].updating = false
    }
  },
  setOffline: (state, isOffline) => {
    console.log({ isOffline })
    Object.assign(state, { isOffline })
  },
}
